import * as yup from "yup";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";
export type TankInstallationFormProps = {
  id: string;
  returnPath: string;
  title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: TankInstallationInput;
  action: "post" | "put";
};


export type TankInstallationInput = {
    tankInstallationId: number
    applicationId: number;
    applicationInspectionId: number;
    tankComplianceId: number;
    tankCompliance? : ComplianceOptions
    tankSizeComment: string;
    tankSize1: number;
    units?: string;
    atuPbtsComplianceId?: number;
    atuPbtsCompliance?: ComplianceOptions;
    atuPbtsComment?: string;
    atuMakeId?: number | null;
    atuMake?: string;
    tankSize2: number;
    tankMaterialComplianceId: number;
    tankMaterialCompliance?: ComplianceOptions;
    tankMaterialComment: string;
    tankMaterialId1: number;
    tankMaterialId2: number;
    outletDeviceComplianceId: number;
    outletDeviceCompliance?: ComplianceOptions;
    outletDeviceComment: string;
    multiChamberedComplianceId: number;
    multiChamberedCompliance?: ComplianceOptions;
    multiChamberedComment: string;
    multiChambered?: string | null;
    tanksInSeries1?: string | null;
    outletFilterComplienceId: number;
    outletFilterComplience?: ComplianceOptions;
    outletFilterComment: string;
    outletFilterId: number;
    legendComplianceId: number;
    legendCompliance?: ComplianceOptions;
    legendComment: string;
    legendId1: number;
    legendId2: number;
    watertightComplianceId: number;
    watertightCompliance?: ComplianceOptions;
    watertightComment: string;
    levelComplianceId: number;
    levelCompliance?: ComplianceOptions;
    levelComment: string;
    depthToLidComplianceId: number;
    depthToLidCompliance?: ComplianceOptions;
    depthToLidComment: string;
    depthToLid?: number;
    riser?: string;
    inspectionStatusId: number;
    tank2ComplianceId: number;
    tank2Compliance?: ComplianceOptions;
    tank2SizeComment: string;
    tank2MaterialComplianceId: number;
    tank2MaterialCompliance?: ComplianceOptions;
    tank2MaterialComment: string;
    tank2LegendComplianceId: number;
    tank2LegendCompliance?: ComplianceOptions;
    tank2LegendComment: string;
    units2?: string;
    atuPbtsComplianceId2?: number;
    atuPbtsComment2?: string;
    atuMakeId2?: number | null;
    outletDeviceComplianceId2?: number;
    outletDeviceComment2?: string;
    multiChamberedComplianceId2?: number;
    multiChamberedComment2?: string;
    multiChambered2?: string | null;
    tanksInSeries2?: string | null;
    outletFilterComplienceId2?: number;
    outletFilterComment2?: string;
    outletFilterId2?: number | null;
    watertightComplianceId2?: number;
    watertightComment2?: string;
    levelComplianceId2?: number;
    levelComment2?: string;
    depthToLidComplianceId2?: number;
    depthToLidComment2?: string;
    depthToLid2?: number;
    riser2?: string | null;
    atuMake2?: string;
    atuPbtsComplianceId2Navigation?: ComplianceOptions;
    outletDeviceComplianceId2Navigation?: ComplianceOptions;
    multiChamberedComplianceId2Navigation?: ComplianceOptions;
    outletFilterComplienceId2Navigation?: ComplianceOptions;
    watertightComplianceId2Navigation?: ComplianceOptions;
    levelComplianceId2Navigation?: ComplianceOptions;
    depthToLidComplianceId2Navigation?: ComplianceOptions;
    dateCreated: Date | string;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    markAll: number;
    tankMaterialId1Navigation?: TankMaterialDto;
    tankMaterialId2Navigation?: TankMaterialDto;
    legendId1Navigation: LegendDto;
    legendId2Navigation:LegendDto;
    outletFilter:OutletFilterDto;
    outletFilter2:OutletFilterDto;
    isTank2Showable:boolean;
    //New columns:
    tankMaterialOtherDescription: string;
    tank2MaterialOtherDescription: string;
};
export type ComplianceData = {
  id: string;
  name: string;

};
export type TankMaterialDto = {
    tankMaterialId : number;
    tankMaterialValue : string;
    sortOrder? : number;

};

export type LegendDto= {
    legendId: number;
    legendValue?: string;
    sortOrder?: number;
}

export type OutletFilterDto = {
    outletFilterId: number;
    outletFilterValue?: string;
    sortOrder?: number;
}

export type TankMaterialData = {
    id: string;
    name: string;

};

export type LegendData = {
    id: string;
    name: string;

};

export type OutletFilterData = {
    id: string;
    name: string;

};

export type AtuMakeData = {
    id: string | number;
    name: string;
};

export const schema = yup.object().shape({

    tankComplianceId: yup
        .number()
        .min(1, "Tank Size Compliance is required")
        .required("Tank Size Compliance is required")
        .typeError("Tank Size Compliance is required"),
    tankSize1: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
    .when("tankComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .integer("Tank Size must be an Integer")
        .min(1, "Tank Size (gal/gpd) must be greater than 0")       
        .required("Tank Size (gal/gpd) is required")
        .typeError("Tank Size (gal/gpd)  is required")
    }),
    tankSizeComment: yup.string().nullable(true)
        .when("tankComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Size Compliance Comment is required")
                .typeError("Tank Size ComplianceComment is required"),
        }),
    units: yup.string().nullable(true)
        .when("tankComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.string()
                .required("Units (gal/gpd) is required")
                .typeError("Units (gal/gpd) is required")
        }),
    atuPbtsComplianceId: yup
        .number()
        .min(1, "ATU/PBTS is required")
        .required("ATU/PBTS is required")
        .typeError("ATU/PBTS is required"),
    atuMakeId: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
        .when("atuPbtsComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.number()
                .min(1, "Make and Model is required")
                .required("Make and Model is required")
                .typeError("Make and Model is required")
        }),
    atuPbtsComment: yup.string().nullable(true)
        .when("atuPbtsComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("ATU/PBTS comment is required")
                .typeError("ATU/PBTS comment is required"),
        }),



    tankMaterialComplianceId: yup
        .number()
        .min(1, "Tank Material Compliance is required")
        .required("Tank Material Compliance is required")
        .typeError("Tank Material Compliance is required"),
    tankMaterialId1: yup.number().nullable(true)
    .when("tankMaterialComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Tank Material Type is required")
        .required("Tank Material Type is required")
        .typeError("Tank Material Type is required")
    }),
    tankMaterialComment: yup.string().nullable(true)
        .when("tankMaterialComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Material Type Comment is required")
                .typeError("Tank Material Type Comment is required"),
        }),
tankMaterialOtherDescription: yup.string().nullable(true)
    .when('tankMaterialId1', {
        is: (tankMaterialId1: number) => tankMaterialId1 === -1, // -1 represents "Other" option
        then: yup.string()
            .required("Tank Material Other Description is required")
            .typeError("Tank Material Other Description is required"),
        otherwise: yup.string().nullable().notRequired()
    }),



    outletDeviceComplianceId: yup
        .number()
        .min(1, "Tank Outlet Device Compliance is required")
        .required("Tank Outlet Device Compliance is required")
        .typeError("Tank Outlet Device Compliance is required"),
  
    outletDeviceComment: yup.string().nullable(true)
        .when("outletDeviceComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Outlet Device Comment is required")
                .typeError("Tank Outlet Device Comment is required"),
        }),



    multiChamberedComplianceId: yup
        .number()
        .min(1, "Tank MultiChambered Compliance is required")
        .required("Tank MultiChambered Compliance is required")
        .typeError("Tank MultiChambered Compliance is required"),
    multiChambered: yup.string().nullable(true)
        .transform((value, originalValue) => {
            if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
            return originalValue;
        })
        .when("multiChamberedComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.string()
                .nullable(true)
                .oneOf(["Yes", "No"], "Is Tank Multichambered? is required")
                .required("Is Tank Multichambered? is required")
                .typeError("Is Tank Multichambered? is required")
        }),
    tanksInSeries1: yup.string().nullable(true)
        .transform((value, originalValue) => {
            if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
            return originalValue;
        })
        .when("multiChamberedComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.string()
                .nullable(true)
                .oneOf(["Yes", "No"], "Tanks In Series? is required")
                .required("Tanks In Series? is required")
                .typeError("Tanks In Series? is required")
        }),
    multiChamberedComment: yup.string().nullable(true)
        .when("multiChamberedComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank MultiChambered Comment is required")
                .typeError("Tank MultiChambered Comment is required"),
        }),



    outletFilterComplienceId: yup
        .number()
        .min(1, "Tank Outlet Filter Compliance is required")
        .required("Tank Outlet Filter Compliance is required")
        .typeError("Tank Outlet Filter Compliance is required"),
    outletFilterId: yup.number().nullable(true)
    .when("outletFilterComplienceId", {
      is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Out_of_Compliance && val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Tank Outlet Filter Type is required")
        .required("Tank Outlet Filter Type is required")
        .typeError("Tank Outlet Filter Type is required")
    }),
    outletFilterComment: yup.string().nullable(true)
        .when("outletFilterComplienceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Outlet Filter Type Comment is required")
                .typeError("Tank Outlet Filter Type Comment is required"),
        }),


  
    legendComplianceId: yup
        .number()
        .min(1, "Tank Legend Compliance is required")
        .required("Tank Legend Compliance is required")
        .typeError("Tank Legend Compliance is required"),
    legendId1: yup.number()
        .min(1, "Tank Legend Type is required")
        .required("Tank Legend Type is required")
        .typeError("Tank Legend Type is required"),
    legendComment: yup.string().nullable(true)
        .when("legendComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Legend Type Comment is required")
                .typeError("Tank Legend Type Comment is required"),
        }),
    

   
    watertightComplianceId: yup
        .number()
        .min(1, "Tank Watertight Compliance is required")
        .required("Tank Watertight Compliance is required")
        .typeError("Tank Watertight Compliance is required"),
   
    watertightComment: yup.string().nullable(true)
        .when("watertightComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Watertight Comment is required")
                .typeError("Tank Watertight Comment is required"),
        }),



    levelComplianceId: yup
        .number()
        .min(1, "Tank Level Compliance is required")
        .required("Tank Level Compliance is required")
        .typeError("Tank Level Compliance is required"),

    levelComment: yup.string().nullable(true)
        .when("levelComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Level Comment is required")
                .typeError("Tank Level Comment is required"),
        }),

    depthToLidComplianceId: yup
        .number()
        .min(1, "Tank Depth To Lid Compliance is required")
        .required("Tank Depth To Lid Compliance is required")
        .typeError("Tank Depth To Lid Compliance is required"),
    depthToLid: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
        .when("depthToLidComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.number()
                .min(0, "Depth to Lid (inches) is required")
                .required("Depth to Lid (inches) is required")
                .typeError("Depth to Lid (inches) is required")
        }),
    riser: yup.string().nullable(true)
        .when("depthToLidComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.string()
                .required("Riser(s) is required")
                .typeError("Riser(s) is required")
        }),

    depthToLidComment: yup.string().nullable(true)
        .when("depthToLidComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Tank Depth To Lid Comment is required")
                .typeError("Tank Depth To Lid Comment is required"),
        }),

    /*=======================================================================================*/
    tank2ComplianceId: yup
        .number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Tank 2 Size Compliance is required")
                .required("Tank 2 Size Compliance is required")
                .typeError("Tank 2 Size Compliance is required"),
        }),


    tankSize2: yup.number()
    .integer("Tank 2 Size must be an Integer")
    .min(1, "Tank 2 Size (gal/gpd) must be greater than 0").nullable(true)
    .when(['isTank2Showable', 'tank2ComplianceId'], {
    is: (val: any,tank2ComplianceId: any) => val === true && (tank2ComplianceId != Constants.Not_Applicable &&  tank2ComplianceId != Constants.Unobserved),

    then: yup.number().integer("Tank 2 Size must be an Integer")
    .min(1, "Tank 2 Size (gal/gpd) must be greater than 0")
    .required("Tank 2 Size (gal/gpd) is required")
    .typeError("Tank 2 Size (gal/gpd)  is required"),
      }),

    tank2SizeComment: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("tank2ComplianceId", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Tank 2 Size Compliance Comment is required")
                        .typeError("Tank 2 Size ComplianceComment is required"),
                }),
        }),

    tank2MaterialComplianceId: yup
        .number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Tank 2 Material Compliance is required")
                .required("Tank 2 Material Compliance is required")
                .typeError("Tank 2 Material Compliance is required"),
        }),
    tankMaterialId2: yup.number().nullable(true)
    .when(['isTank2Showable', 'tank2MaterialComplianceId'], {
        is: (val: any,tank2MaterialComplianceId: any) => val === true && 
        (tank2MaterialComplianceId != Constants.Not_Applicable &&  tank2MaterialComplianceId != Constants.Unobserved),
        
            then: yup.number()
                .min(1, "Tank 2 Material Type is required")
                .required("Tank 2 Material Type is required")
                .typeError("Tank 2 Material Type is required"),
        }),
    tank2MaterialComment: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("tank2MaterialComplianceId", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Tank 2 Material Type Comment is required")
                        .typeError("Tank 2 Material Type Comment is required"),
                }),
        }),

         tank2MaterialOtherDescription: yup.string().nullable(true)
     .when(['isTank2Showable', 'tankMaterialId2'], {
         is: (isTank2Showable: boolean, tankMaterialId2: number) => 
             isTank2Showable && 
             tankMaterialId2 === -1, // -1 represents "Other" option
         then: yup.string()
             .required("Tank 2 Material Other Description is required")
             .typeError("Tank 2 Material Other Description is required"),
         otherwise: yup.string().nullable().notRequired()
     }),

    tank2LegendComplianceId: yup
        .number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Tank 2 Legend Compliance is required")
                .required("Tank 2 Legend Compliance is required")
                .typeError("Tank 2 Legend Compliance is required"),
        }),
    legendId2: yup.number().nullable(true)
            .when(['isTank2Showable', 'tank2LegendComplianceId'], {
                is: (val: any,tank2LegendComplianceId: any) => val === true && 
                (tank2LegendComplianceId != Constants.Not_Applicable &&  tank2LegendComplianceId != Constants.Unobserved),
                
            then: yup.number()
                .min(1, "Tank 2 Legend Type is required")
                .required("Tank 2 Legend Type is required")
                .typeError("Tank 2 Legend Type is required"),
        }),
    tank2LegendComment: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("tank2LegendComplianceId", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Tank 2 Legend Type Comment is required")
                        .typeError("Tank 2 Legend Type Comment is required"),
                }),
        }),

    units2: yup.string().nullable(true)
        .when(["isTank2Showable", "tank2ComplianceId"], {
            is: (val: any, tank2ComplianceId: any) => val === true && (tank2ComplianceId != Constants.Not_Applicable && tank2ComplianceId != Constants.Unobserved),
            then: yup.string()
                .required("Units (gal/gpd) is required")
                .typeError("Units (gal/gpd) is required")
        }),

    atuPbtsComplianceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "ATU/PBTS is required")
                .required("ATU/PBTS is required")
                .typeError("ATU/PBTS is required"),
        }),
    atuMakeId2: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
        .when(["isTank2Showable", "atuPbtsComplianceId2"], {
            is: (val: any, atuPbtsComplianceId2: any) => val === true && (atuPbtsComplianceId2 != Constants.Not_Applicable && atuPbtsComplianceId2 != Constants.Unobserved),
            then: yup.number()
                .min(1, "Make and Model is required")
                .required("Make and Model is required")
                .typeError("Make and Model is required")
        }),
    atuPbtsComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("atuPbtsComplianceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("ATU/PBTS comment is required")
                        .typeError("ATU/PBTS comment is required"),
                }),
        }),

    outletDeviceComplianceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Inlet / Outlet Device Compliance is required")
                .required("Inlet / Outlet Device Compliance is required")
                .typeError("Inlet / Outlet Device Compliance is required"),
        }),
    outletDeviceComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("outletDeviceComplianceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Inlet / Outlet Device Comment is required")
                        .typeError("Inlet / Outlet Device Comment is required"),
                }),
        }),

    multiChamberedComplianceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Tank Multichambered Compliance is required")
                .required("Tank Multichambered Compliance is required")
                .typeError("Tank Multichambered Compliance is required"),
        }),
    multiChambered2: yup.string().nullable(true)
        .transform((value, originalValue) => {
            if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
            return originalValue;
        })
        .when(["isTank2Showable", "multiChamberedComplianceId2"], {
            is: (val: any, multiChamberedComplianceId2: any) => val === true && (multiChamberedComplianceId2 != Constants.Not_Applicable && multiChamberedComplianceId2 != Constants.Unobserved),
            then: yup.string()
                .nullable(true)
                .oneOf(["Yes", "No"], "Is Tank Multichambered? is required")
                .required("Is Tank Multichambered? is required")
                .typeError("Is Tank Multichambered? is required")
        }),
    tanksInSeries2: yup.string().nullable(true)
        .transform((value, originalValue) => {
            if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
            return originalValue;
        })
        .when(["isTank2Showable", "multiChamberedComplianceId2"], {
            is: (val: any, multiChamberedComplianceId2: any) => val === true && (multiChamberedComplianceId2 != Constants.Not_Applicable && multiChamberedComplianceId2 != Constants.Unobserved),
            then: yup.string()
                .nullable(true)
                .oneOf(["Yes", "No"], "Tanks In Series? is required")
                .required("Tanks In Series? is required")
                .typeError("Tanks In Series? is required")
        }),
    multiChamberedComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("multiChamberedComplianceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Tank Multichambered Comment is required")
                        .typeError("Tank Multichambered Comment is required"),
                }),
        }),

    outletFilterComplienceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Tank Outlet Filter Compliance is required")
                .required("Tank Outlet Filter Compliance is required")
                .typeError("Tank Outlet Filter Compliance is required"),
        }),
    outletFilterId2: yup.number().nullable(true)
        .when(["isTank2Showable", "outletFilterComplienceId2"], {
            is: (val: any, outletFilterComplienceId2: any) => val === true && (outletFilterComplienceId2 != Constants.Not_Applicable && outletFilterComplienceId2 != Constants.Out_of_Compliance && outletFilterComplienceId2 != Constants.Unobserved),
            then: yup.number()
                .min(1, "Outlet Filter Make & Model is required")
                .required("Outlet Filter Make & Model is required")
                .typeError("Outlet Filter Make & Model is required")
        }),
    outletFilterComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("outletFilterComplienceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Tank Outlet Filter Comment is required")
                        .typeError("Tank Outlet Filter Comment is required"),
                }),
        }),

    watertightComplianceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Watertight Compliance is required")
                .required("Watertight Compliance is required")
                .typeError("Watertight Compliance is required"),
        }),
    watertightComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("watertightComplianceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Watertight Comment is required")
                        .typeError("Watertight Comment is required"),
                }),
        }),

    levelComplianceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Level Compliance is required")
                .required("Level Compliance is required")
                .typeError("Level Compliance is required"),
        }),
    levelComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("levelComplianceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Level Comment is required")
                        .typeError("Level Comment is required"),
                }),
        }),

    depthToLidComplianceId2: yup.number().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.number()
                .min(1, "Depth to Lid Compliance is required")
                .required("Depth to Lid Compliance is required")
                .typeError("Depth to Lid Compliance is required"),
        }),
    depthToLid2: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
        .when(["isTank2Showable", "depthToLidComplianceId2"], {
            is: (val: any, depthToLidComplianceId2: any) => val === true && (depthToLidComplianceId2 != Constants.Not_Applicable && depthToLidComplianceId2 != Constants.Unobserved),
            then: yup.number()
                .min(0, "Depth to Lid (inches) is required")
                .required("Depth to Lid (inches) is required")
                .typeError("Depth to Lid (inches) is required")
        }),
    riser2: yup.string().nullable(true)
        .when(["isTank2Showable", "depthToLidComplianceId2"], {
            is: (val: any, depthToLidComplianceId2: any) => val === true && (depthToLidComplianceId2 != Constants.Not_Applicable && depthToLidComplianceId2 != Constants.Unobserved),
            then: yup.string()
                .required("Riser(s) is required")
                .typeError("Riser(s) is required")
        }),
    depthToLidComment2: yup.string().nullable(true)
        .when("isTank2Showable", {
            is: (val: any) => val === true,
            then: yup.string().nullable(true)
                .when("depthToLidComplianceId2", {
                    is: (val: any) => val === Constants.Out_of_Compliance,
                    then: yup.string()
                        .required("Depth to Lid Comment is required")
                        .typeError("Depth to Lid Comment is required"),
                }),
        }),

});
/*=======================================================================================*/

